import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

registerLocaleData(localeDe, 'de');

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injector } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { createCustomElement } from "@angular/elements";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { AngularSplitModule } from 'angular-split'
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ToastrModule } from 'ngx-toastr';
import { NgxAwesomePopupModule, ConfirmBoxConfigModule } from '@costlydeveloper/ngx-awesome-popup';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { QuillModule } from 'ngx-quill'
import 'quill';

import { SharedService } from './shared';

import { HeaderComponent } from './header';
import { DocCheckLoginComponent } from './doc-check-login';
import {
    DateneingabeFragebogeComponent
} from './dateneingabe-frageboge/dateneingabe-frageboge.component';
import {
    DateneingabeFragebogeCommonComponent,
    ICDCodePopupComponent,
    SymptomeComponent,
    MedikamentComponent,
    CamTherapieComponent,
    PosNegSliderComponent,
    PEPInfoComponent
} from './dateneingabe-frageboge';

import {
    CardDetailPopupComponent,
    RatingGraphComponent,
    CaseSharePopupComponent,
    RezeptConfigPopupComponent,
    PrescriptionPopupComponent
} from './card-detail-popup';

import { DatenebankCardsComponent } from './datenebank-cards'
import { DatenebankCardsENComponent } from './datenebank-cards-en'

import { DatenebankSharedCaseComponent } from './shared-case';
import { DatenebankSharedCaseENComponent } from './shared-case-en';

import { DatenubersichtComponent, DatenubersichtENComponent, DatenubersichtInfoComponent } from './datenubersicht';

const Components = [
    HeaderComponent,
    DocCheckLoginComponent,
    DateneingabeFragebogeCommonComponent,
    DateneingabeFragebogeComponent,
    ICDCodePopupComponent,
    SymptomeComponent,
    MedikamentComponent,
    CamTherapieComponent,
    PosNegSliderComponent,
    PEPInfoComponent,
    DatenebankCardsComponent,
    DatenebankCardsENComponent,
    CardDetailPopupComponent,
    RatingGraphComponent,
    CaseSharePopupComponent,
    RezeptConfigPopupComponent,
    PrescriptionPopupComponent,
    DatenebankSharedCaseComponent,
    DatenebankSharedCaseENComponent,
    DatenubersichtComponent,
    DatenubersichtInfoComponent,
    DatenubersichtENComponent
]

import { ClickOutsideDirective } from './shared/click-outside.directive';

const Directives = [
    ClickOutsideDirective
];


@NgModule({
    declarations: [
        ...Components,
        ...Directives
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        NgbModule,
        NgxSliderModule,
        AngularSplitModule,
        NgSelectModule,
        BsDatepickerModule.forRoot(),
        PaginationModule.forRoot(),
        ToastrModule.forRoot({
            positionClass: 'toast-top-center',
            preventDuplicates: true,
            enableHtml: true,
            maxOpened: 1,
            autoDismiss: true,
            timeOut: 3000
        }),
        NgxAwesomePopupModule.forRoot(),
        ConfirmBoxConfigModule.forRoot({
            confirmBoxCoreConfig: {
                allowHtmlMessage: true
            }
        }),
        DragDropModule,
        QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic']
                ]
            }
        })
    ],
    providers: [
        SharedService
    ]
})
export class AppModule {
    constructor(private injector: Injector) { }

    ngDoBootstrap() {
        const DocCheckLoginHostElement = createCustomElement(DocCheckLoginComponent, {
            injector: this.injector
        });
        customElements.define("doc-check-login-host-element", DocCheckLoginHostElement);

        const DateneingabeFragebogeHostElement = createCustomElement(DateneingabeFragebogeComponent, {
            injector: this.injector
        });
        customElements.define("dateneingabe-frageboge-host-element", DateneingabeFragebogeHostElement);

        const DatenebankCardsHostElement = createCustomElement(DatenebankCardsComponent, {
            injector: this.injector
        });
        customElements.define("datenebank-cards-host-element", DatenebankCardsHostElement);

        const DatenebankCardsENHostElement = createCustomElement(DatenebankCardsENComponent, {
            injector: this.injector
        });
        customElements.define("datenebank-cards-en-host-element", DatenebankCardsENHostElement);


        const SharedCaseHostElement = createCustomElement(DatenebankSharedCaseComponent, {
            injector: this.injector
        });
        customElements.define("datenebank-shared-case-host-element", SharedCaseHostElement);

        const SharedCaseENHostElement = createCustomElement(DatenebankSharedCaseENComponent, {
            injector: this.injector
        });
        customElements.define("datenebank-shared-case-en-host-element", SharedCaseENHostElement);

        const DatenubersichtHostElement = createCustomElement(DatenubersichtComponent, {
            injector: this.injector
        });
        customElements.define("datenubersicht-host-element", DatenubersichtHostElement);

        const DatenubersichtENHostElement = createCustomElement(DatenubersichtENComponent, {
            injector: this.injector
        });
        customElements.define("datenubersicht-en-host-element", DatenubersichtENHostElement);
    }
}
